import Image from 'next/image';
import React from 'react';

const EnterpriseDataEngineering = () => {
    return (
        <div
            className="section-py dark:text-light border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="mb-[10px] dark:text-white"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Enterprise Data Engineering That Powers Reliable, Scalable AI and Analytics
                        </h2>
                        <p className="dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Modern AI strategies depend on strong, production-ready data foundations. Our Data Engineering & Foundations services help organizations build scalable, secure, and high-performing data infrastructure that powers analytics and AI transformation. From data pipeline development to cloud migration, we enable enterprises to become truly data-driven.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7 mb-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-safe-productive.svg"
                                        width={36}
                                        height={36}
                                        alt="safe-productive"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Design and automate modern ETL/ELT pipelines for faster, reliable, and consistent data movement across systems.
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-orchestrated-agent.svg"
                                        width={36}
                                        height={36}
                                        alt="Orchestrated agents"
                                    />
                                </div>

                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Architect cloud-native data warehouses and lakes that unify fragmented data into one trusted environment.
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-7">
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-mcp-powered.svg"
                                        width={36}
                                        height={36}
                                        alt="MCP-powered controls"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Enable real-time streaming and analytics for instant insights supporting AI-driven decision-making.
                                </p>
                            </div>
                            <div className="flex flex-col gap-[9px] card p-5 bg-white rounded-10 border dark:border-[#ffffff33] dark:border-solid dark:bg-[#3C45611A]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                                <div className="voice-generator-box">
                                    <Image
                                        src="/img/ai-agent/svg/ic-ai-automation.svg"
                                        width={36}
                                        height={36}
                                        alt="AI automation"
                                    />
                                </div>
                                <p className="fs-md mb-0 dark:text-[#D7DEE5]">
                                    Implement DataOps automation, governance, and monitoring to accelerate analytics and AI-readiness.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnterpriseDataEngineering;
